import ChessNav from './ChessNav';
import Icon from '../Shared/Icons';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Chess } from 'chess.js';
import ChessBoard from './ChessBoard';

const LESSONS = [
  {
    icon: '♙', title: 'Pawn (Kombamwiko)',
    text: 'Pawn husogea hatua moja mbele (mbili kwa hatua ya kwanza), lakini hukamata kwa mshazari. Ndio kipande dhaifu zaidi, lakini kikifika mwisho wa ubao hubadilika kuwa kipande chochote unachotaka!',
  },
  {
    icon: '♘', title: 'Knight (Farasi)',
    text: 'Knight husogea kwa umbo la "L" — hatua mbili upande mmoja, kisha hatua moja kando. Ndiye kipande pekee anayeweza kuruka juu ya vipande vingine.',
  },
  {
    icon: '♗', title: 'Bishop (Askofu)',
    text: 'Bishop husogea mshazari tu, umbali wowote. Kila bishop hubaki kwenye rangi moja ya boksi mchezo mzima.',
  },
  {
    icon: '♖', title: 'Rook (Ngome)',
    text: 'Rook husogea moja kwa moja — juu, chini, kushoto, kulia — umbali wowote. Ana nguvu sana kwenye mistari na safu wazi.',
  },
  {
    icon: '♕', title: 'Queen (Malkia)',
    text: 'Queen ni kipande chenye nguvu zaidi — husogea kama Rook na Bishop kwa pamoja: mstari wowote au mshazari, umbali wowote.',
  },
  {
    icon: '♔', title: 'King (Mfalme)',
    text: 'King husogea hatua moja tu kwa mwelekeo wowote. Lengo la mchezo ni kumlinda King wako na kumshambulia King wa mpinzani (Checkmate).',
  },
  {
    icon: 'flag', title: 'Check & Checkmate',
    text: '"Check" ni pale King anaposhambuliwa moja kwa moja. "Checkmate" ni pale King hawezi kutoroka shambulio — hapo ndipo mchezo unaisha.',
  },
];

export default function ChessLearn() {
  const navigate = useNavigate();
  const [practiceFen, setPracticeFen] = useState(new Chess().fen());
  const [activeLesson, setActiveLesson] = useState(0);

  function handlePracticeMove(moveResult) {
    setPracticeFen(moveResult.fen);
  }

  function resetPractice() {
    setPracticeFen(new Chess().fen());
  }

  return (
    <div style={styles.page}>
      <div style={styles.bar}>
        <button style={styles.backIconBtn} onClick={() => navigate('/chess')}>
          <Icon name="door" size={19} color="#ECEFEA" strokeWidth={2.4} />
        </button>
        <div style={styles.barTitle}>Jifunze</div>
        <div style={{ width: '38px' }} />
      </div>

      <div style={styles.lessonTabs}>
        {LESSONS.map((l, i) => (
          <button
            key={i}
            style={{ ...styles.lessonTab, ...(activeLesson === i ? styles.lessonTabActive : {}) }}
            onClick={() => setActiveLesson(i)}
          >
            {l.icon}
          </button>
        ))}
      </div>

      <div style={styles.lessonCard}>
        <div style={styles.lessonTitle}>{LESSONS[activeLesson].icon} {LESSONS[activeLesson].title}</div>
        <div style={styles.lessonText}>{LESSONS[activeLesson].text}</div>
      </div>

      <div style={styles.practiceSection}>
        <div style={styles.practiceHeader}>
          <span style={styles.practiceTitle}>Practice Board</span>
          <button style={styles.resetBtn} onClick={resetPractice}>↺ Reset</button>
        </div>
        <div style={styles.practiceHint}>
          Both sides are playable — try out what you just learned. No rating, no pressure.
        </div>
        <ChessBoard
          fen={practiceFen}
          onMove={handlePracticeMove}
          interactive={true}
          playerColor={null}
        />
      </div>
      <ChessNav />
    </div>
  );
}

const styles = {
  bar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px' },
  backIconBtn: { width: '38px', height: '38px', borderRadius: '11px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.09)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  barTitle: { color: '#ECEFEA', fontFamily: "'Fraunces', Georgia, serif", fontSize: '19px', fontWeight: '800' },

  page: { minHeight: '100vh', background: 'radial-gradient(circle at 30% 0%, #262D2A 0%, #1B201E 48%, #121614 100%)', padding: '20px 16px 60px', paddingBottom: '100px' },
  header: { maxWidth: '560px', margin: '0 auto 18px' },
  backLink: { color: 'rgba(255,255,255,0.6)', fontSize: '13px', textDecoration: 'none' },
  title: { color: '#fff', fontFamily: "'Fraunces', Georgia, serif", fontSize: '22px', marginTop: '8px' },
  subtitle: { color: 'rgba(255,255,255,0.45)', fontSize: '12.5px', marginTop: '3px' },
  lessonTabs: { maxWidth: '560px', margin: '0 auto 12px', display: 'flex', gap: '8px', flexWrap: 'wrap' },
  lessonTab: { width: '42px', height: '42px', borderRadius: '10px', background: 'rgba(255,255,255,0.07)', border: '1.5px solid rgba(255,255,255,0.12)', color: '#fff', fontSize: '22px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  lessonTabActive: { background: 'rgba(16,185,129,0.25)', borderColor: '#10B981' },
  lessonCard: { maxWidth: '560px', margin: '0 auto 20px', background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '16px', padding: '18px' },
  lessonTitle: { color: '#fff', fontFamily: "'Fraunces', Georgia, serif", fontSize: '17px', marginBottom: '8px' },
  lessonText: { color: 'rgba(255,255,255,0.65)', fontSize: '13px', lineHeight: 1.7 },
  practiceSection: { maxWidth: '560px', margin: '0 auto' },
  practiceHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' },
  practiceTitle: { color: '#fff', fontSize: '13.5px', fontWeight: '700' },
  resetBtn: { background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.7)', padding: '6px 12px', borderRadius: '8px', fontSize: '11.5px', cursor: 'pointer', fontFamily: 'inherit' },
  practiceHint: { color: 'rgba(255,255,255,0.4)', fontSize: '11.5px', marginBottom: '12px' },
};
